// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"styles_videoWrapper__Cclps","videoOverlay":"styles_videoOverlay__B3o4O","playButton":"styles_playButton__1QfHE"};